import React from 'react';
import {IconButton, Stack, Typography, useTheme} from '@mui/material';

import Icon from 'presentation/icons';
import {useMediaQueries} from 'presentation/pages';
import {StyledRouteContainer} from '../styles';
import {SubRouteHandlerProps} from './types';

export function SubRouteHandler({
	title,
	handleBack,
	handleClose,
	hideClose,
	hideBackBtn,
	dataTagId,
}: SubRouteHandlerProps) {
	const theme = useTheme();
	const {aboveMobile, isMobile} = useMediaQueries();
	const hideActions = hideClose || hideBackBtn;

	return (
		<StyledRouteContainer>
			<Stack flexDirection="row" gap={1.5} alignItems="center" overflow="hidden">
				{hideBackBtn ? null : (
					<IconButton
						data-tag-id={dataTagId?.backButton}
						onClick={handleBack}
						sx={{pl: aboveMobile ? 0 : 1}}>
						<Icon name="arrow-left-filled" color={theme.palette.common.white} />
					</IconButton>
				)}
				<Typography
					paddingLeft={hideActions && isMobile ? 1 : 0}
					textOverflow="ellipsis"
					overflow="hidden"
					whiteSpace="nowrap"
					fontWeight={isMobile ? 600 : 400}
					fontSize={isMobile ? '1.25rem' : '1.5rem'}
					variant="h6">
					{title}
				</Typography>
			</Stack>
			{hideClose ? null : (
				<IconButton onClick={handleClose} data-tag-id={dataTagId?.closeButton}>
					<Icon name="close-filled" color={theme.palette.common.white} />
				</IconButton>
			)}
		</StyledRouteContainer>
	);
}
